// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LoadingWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  margin: "var(--ds-space-050, 4px)".concat(" 0")
});